import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService, OptionsserviceService, LoansService, OperationsService } from '../../_services/index';
import { CustomerService, StorageService } from '../../_services/index';

@Component({
  selector: 'app-postingbulkpaymentscalendar',
  templateUrl: './postingbulkpaymentscalendar.component.html',
  styleUrls: ['./postingbulkpaymentscalendar.component.css']
})
export class PostingbulkpaymentscalendarComponent implements OnInit {
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  direction = '';
  is_done = false;
  currentUser: any;
  repayments:any;
  loading = false;
  has_data = false;
  searchString = '';
  @Input('payment_date') payment_date='';
  @Input('showing_due_loans') showing_due_loans = false;
  @Input('show_for_account_officer') show_for_account_officer = false;
  param = {
    'search_string':'',
    'start':'0'
  }
  adding = true;
  added_requests = [];
  send_payments_to_queue = '0';
  start = '0';
  has_more = false;
  constructor(private operationsService: OperationsService,public storageService: StorageService, private dataService: DataService) { 
    this.currentUser = this.storageService.read<any>('currentUser');
  }

  ngOnInit() {
    console.log(this.showing_due_loans)
   //this.getDueRepayments();
   if(this.showing_due_loans){
      this.getDueRepayments();
    }else{
      this.getPaymentsForTheScheduleDate();
    }
   
  }
  getPaymentsForTheScheduleDate(){
    this.loading = true;
    this.operationsService.getPaymentsForTheScheduleDate(this.currentUser.token,this.param, this.payment_date,this.show_for_account_officer)
      .subscribe(result => {
        this.loading = false;
        this.has_data = result.has_data;
        this.repayments = result.message;
        this.send_payments_to_queue = result.send_payments_to_queue;
        
      });
  }
  
  getDueRepayments(){
    this.loading = true;
    this.operationsService.getBulkRepayments(this.currentUser.token,this.param,this.show_for_account_officer)
      .subscribe(result => {
        this.loading = false;
        this.has_data = result.has_data;
        this.repayments = result.message;
        this.send_payments_to_queue = result.send_payments_to_queue;
        this.start = result.start;
        this.has_more = result.has_more;
        this.param.start = result.start;
      });
  }
  loanmoregetDueRepayments(){
    this.loading = true;
    this.operationsService.getBulkRepayments(this.currentUser.token,this.param)
      .subscribe(result => {
        this.loading = false;
        this.has_data = result.has_data;
        result.message.map(x => this.repayments.push(x))
        this.send_payments_to_queue = result.send_payments_to_queue;
        this.start = result.start;
        this.has_more = result.has_more;
        this.param.start = result.start;
      });
  }
  postDuePayments(){
    // this.loading = true;
    // this.operationsService.postDuePayments(this.currentUser.token,this.repayments,this.payment_date)
    //   .subscribe(result => {
    //     this.loading = false; 
    //   });
    this.loading = true;
    this.loading = false; 
    this.is_done = true;
    this.operationsService.postDuePayments(
      this.currentUser.token,
      this.added_requests,
      this.payment_date
    );
  }
  addRecord(due,i){
    if(this.added_requests.indexOf(due)==-1){
      this.repayments[i].checked = true;
      this.added_requests.push(due);
    }
    
  }
  removeRecord(due,i){
    if(this.added_requests.indexOf(due)!=-1){
      this.repayments[i].checked = false;
      this.added_requests.splice(due,1);
    }
    
  }
  onScrollDown(){

  }
  openSidemenuForDueLoan(due){  
    this.dataService.openSidemenuForDueLoan.emit({due: due});
  }
}
